import * as React from 'react';
import Label from '@components/Label';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby-plugin-react-i18next';
import playIcon from '@icons/playIcon';
import playbookIcon from '@icons/playbookIcon';
import * as styles from './style.module.scss';

const {
  resourceCard,
  resourceCardMostPopular,
  resourceCardTrending,
  resourceCardRelated,
  resourceCardFilters,
  resourceCard__image,
  resourceCard__details,
  resourceCard__category,
  resourceCard__title,
  resourceCard__badge,
  resourceCard__largeBadge,
  resourceCard__date,
  resourceCardPosts,
  resourceCard__playIcons,
  resourceCard__playIconsTitle,
} = styles;

const ResourceCard = ({
  resource,
  classModifier,
  headingLevel = 'h5',
  playTypeLabel = '',
}) => {
  const {
    __typename,
    author,
    datePublished,
    dateModified,
    headerImage,
    permalink,
    title,
  } = resource;
  const img = getImage(headerImage);
  // Use React.createElement to create the dynamic heading
  const HeadingTag = React.createElement(headingLevel, null, title);

  // Determine the content model type label (e.g., Blog Post or Play)
  const contentTypes = {
    ContentfulBlogPost: { label: 'Blog', url: '/blog' },
    ContentfulPlay: { label: 'Play', url: '/resources/playbooks' },
    ContentfulPageSuccessStory: { label: 'Success Story', url: '/customers' },
    ContentfulStreamEpisode: {
      label: 'Stream',
      url: '/resources/stream/series',
    },
    ContentfulPageProductUpdate: {
      label: 'Product Update',
      url: '/platform/product-updates',
    },
  };
  const contentModelLabel = contentTypes[__typename]?.label;
  let url = `${contentTypes[__typename]?.url ?? ''}/${permalink}`;
  if (__typename === 'ContentfulStreamEpisode') {
    url = `${contentTypes[__typename]?.url ?? ''}/${
      resource.series.slug
    }/${permalink}`;
  }

  return (
    <div
      className={`
      ${resourceCard} ${
        classModifier === 'popular'
          ? resourceCardMostPopular
          : classModifier === 'trending'
          ? resourceCardTrending
          : classModifier === 'posts'
          ? resourceCardPosts
          : classModifier === 'related'
          ? resourceCardRelated
          : classModifier === 'filters'
          ? resourceCardFilters
          : ''
      }
    `}
    >
      <Link to={url} className={`${resourceCard__title}`}>
        <GatsbyImage
          quality={100}
          className={`${resourceCard__image}`}
          image={img}
          alt={headerImage?.description}
        />
        {playTypeLabel && (
          <div
            className={`${resourceCard__badge} ${
              headingLevel === 'h3' ? resourceCard__largeBadge : ''
            }`}
          >
            <span className={`${resourceCard__playIcons}`}>
              {playTypeLabel === 'playbook' ? playbookIcon : playIcon}
            </span>
            <span className={`${resourceCard__playIconsTitle}`}>
              {playTypeLabel}
            </span>
          </div>
        )}
      </Link>
      <div className={`${resourceCard__details}`}>
        {contentModelLabel && (
          <Label classes={resourceCard__category}>{contentModelLabel}</Label>
        )}
        <Link to={url} className={`${resourceCard__title}`}>
          {HeadingTag}
        </Link>
        {datePublished && (
          <span className={resourceCard__date}>{datePublished}</span>
        )}
      </div>
    </div>
  );
};

export default ResourceCard;
